import { useState, useEffect } from 'react';

const usePreloadAssets = (assets) => {
  const [loaded, setLoaded] = useState(false);
  const [loadingPercentage, setLoadingPercentage] = useState(0);

  useEffect(() => {
    const cacheAssets = async (assets) => {
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.ready;
        const cache = await caches.open('my-app-cache-v1');
        await cache.addAll([...assets.images, ...assets.videos]);
      }
    };

    const updateLoadingProgress = (completed, total) => {
      setLoadingPercentage(Math.round((completed / total) * 100));
    };

    const loadImages = () => {
      const imagePromises = assets.images.map((src, index) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = () => {
            updateLoadingProgress(index + 1, assets.images.length + assets.videos.length);
            resolve();
          };
          img.onerror = reject;
        });
      });
      return Promise.all(imagePromises);
    };

    const loadVideos = () => {
      const videoPromises = assets.videos.map((src, index) => {
        return new Promise((resolve, reject) => {
          const video = document.createElement('video');
          video.src = src;
          video.onloadeddata = () => {
            updateLoadingProgress(assets.images.length + index + 1, assets.images.length + assets.videos.length);
            resolve();
          };
          video.onerror = reject;
        });
      });
      return Promise.all(videoPromises);
    };

    const loadAssets = async () => {
      try {
        await loadImages();
        await loadVideos();
        await cacheAssets(assets);
        setLoaded(true);
      } catch (error) {
        console.error('Error loading assets:', error);
      }
    };

    loadAssets();
  }, [assets]);

  return { loaded, loadingPercentage };
};

export default usePreloadAssets;
